import { Link } from "react-router-dom";

export type CrmRecordTab = "overview" | "history";

type CrmRecordTabsProps = {
  basePath: string;
  activeTab: CrmRecordTab;
  searchParams?: URLSearchParams;
};

/** Maps URL `tab` to Overview or History (`timeline` / legacy `emails` → History). */
export function resolveCrmRecordTab(tab?: string | null): CrmRecordTab {
  if (tab === "history" || tab === "timeline" || tab === "emails") return "history";
  return "overview";
}

function tabHref(basePath: string, tab: CrmRecordTab, extra?: URLSearchParams) {
  const params = new URLSearchParams(extra?.toString() || "");
  if (tab === "overview") {
    params.delete("tab");
  } else {
    params.set("tab", "history");
  }
  const nextQuery = params.toString();
  return nextQuery ? `${basePath}?${nextQuery}` : basePath;
}

export function CrmRecordTabs({ basePath, activeTab, searchParams }: CrmRecordTabsProps) {
  const tabs: Array<{ id: CrmRecordTab; label: string }> = [
    { id: "overview", label: "Overview" },
    { id: "history", label: "History" },
  ];

  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-gray-200 pb-3 dark:border-white/10">
      {tabs.map((tab) => (
        <Link
          key={tab.id}
          to={tabHref(basePath, tab.id, searchParams)}
          className={`rounded-md px-3 py-2 text-sm font-medium transition ${
            activeTab === tab.id
              ? "bg-indigo-600 text-white"
              : "border border-gray-300 hover:bg-gray-50 dark:border-white/20 dark:hover:bg-white/10"
          }`}
        >
          {tab.label}
        </Link>
      ))}
    </div>
  );
}
